import { render, staticRenderFns } from "./select_identity.vue?vue&type=template&id=484b1f8c&scoped=true&"
import script from "./select_identity.vue?vue&type=script&lang=js&"
export * from "./select_identity.vue?vue&type=script&lang=js&"
import style0 from "./select_identity.vue?vue&type=style&index=0&id=484b1f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b1f8c",
  null
  
)

export default component.exports